module.exports = __webpack_public_path__ + "img/stacked_bar.83dfdc1b.svg";